import { render, staticRenderFns } from "./beneficial-info.vue?vue&type=template&id=484575f8&"
import script from "./beneficial-info.vue?vue&type=script&lang=js&"
export * from "./beneficial-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports